import React from "react";
import HOC from "../../components/HOC";
import PageTemplate from "../../components/common/particles.jsx/PageTemplate";
import BreadcrumbBillingManual from "../../components/screen/billingManual/BreadcrumbBillingManual";
import { ThemeProvider } from "@mui/material";
import { theme } from "../../components/constants/muiTheme";
import PoListBillingManual from "../../components/screen/billingManual/PoListBillingManual";

const CreateBillingManualPage = ({ isWarehouse }) => {
  return (
    <div className="">
      <PageTemplate
        header={(isWarehouse ? "Central Warehouse " : "") + "Buat Billing Manual"}
        mainComponent={
          <ThemeProvider theme={theme}>
            <PoListBillingManual
              isWarehouse={isWarehouse ? isWarehouse : false}
            />
          </ThemeProvider>
        }
        breadcrumb={
          <BreadcrumbBillingManual
            isWarehouse={isWarehouse ? isWarehouse : false}
          />
        }
        pageRole={isWarehouse ? 28 : 7}
      />
    </div>
  );
};

export default HOC(CreateBillingManualPage);
